import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutDriverManagerProfileFilter extends Layout {
    buttonApply: Button;
    buttonCancel: Button;
    buttonReset: Button;
    horizontalspacer1: HorizontalSpacer;
    labelAdvancedFilter: Label;
    layoutProfile: Layout;
    panelHeader: Panel;
    sourceDriverManagerProfile: DataSource;
}
